import classNames from 'classnames';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { ChangeEvent, FC, SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { trimValueLeft } from 'utils/formValidation/trimValue';
import './Search.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { TextInput } from 'components/TextInput/TextInput';

export const Search: FC = () => {
  const msg = useLocale();
  const [value, setValue] = useState<string>('');
  const navigate = useNavigate();
  const globalStateCtxProps = useGlobalStateContextSelectors({
    theme: prop('user', 'theme'),
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();

    if (value) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`);
      setValue('');
    }
  };

  return (
    <form
      className={classNames(
        'ipf-menu-search',
        globalStateCtxProps.theme === 'dark' ? 'theme--dark' : 'theme--light',
        'flex flex-1 items-center overflow-hidden',
      )}
      onSubmit={handleSubmit}
    >
      <TextInput
        type='search'
        className='flex-1'
        value={value}
        onChange={trimValueLeft(handleChange)}
        placeholder={msg.app.sidebar.menuText.searchPlaceholder}
      />
    </form>
  );
};
